import { i18nTranslate } from 'src/utils'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'

const budgetPeriodOptions = [
  {
    label: i18nTranslate('costcenter.choose', 'Choose'),
    value: '',
  },
  {
    label: i18nTranslate('costcenter.halfyearly', 'Half Yearly'),
    value: 'halfyearly',
  },
  {
    label: i18nTranslate('costcenter.yearly', 'Yearly'),
    value: 'yearly',
  },
]

export const formInput = formRenderProps => {
  let locale = getLocaleCodeFromUrl({
    defaultLocale: 'en_US',
    isReverseType: true,
  })

  locale = locale?.replace('_', '-')

  const convertedStartDate = formRenderProps.startDate
    ? new Date(formRenderProps.startDate).toLocaleDateString(locale)
    : ''
  const convertedEndDate = formRenderProps.endDate
    ? new Date(formRenderProps.endDate).toLocaleDateString(locale)
    : ''

  const formInputData = [
    [
      {
        name: 'totalBudget',
        disabled: true,
        defaultValue: `$ ${formRenderProps.totalBudget}`,
        maxLength: '64',
        columnType: {
          lg: '4',
          md: '3',
          sm: '5',
          xs: '12',
        },
        customClassName: 'budget-form',
        customDataTestId: 'qa-costcenter-budget',
      },
      // {
      //   name: 'budgetPeriod',
      //  disabled: true,
      //   maxLength: '64',
      //   type: 'select',
      //   options: budgetPeriodOptions,
      //   columnType: {
      //     lg: '4',
      //     md: '6',
      //     sm: '6',
      //   },
      // },

      {
        name: 'startDate',
        disabled: true,
        defaultValue: convertedStartDate,
        columnType: {
          lg: '3',
          md: '4',
          sm: '3',
          xs: '5',
        },
        customClassName: 'budget-form mt-2 mt-md-0',
        customDataTestId: 'qa-costcenter-startdate',
      },
      {
        name: 'endDate',
        disabled: true,
        defaultValue: convertedEndDate,
        columnType: {
          lg: '3',
          md: '4',
          sm: '3',
          xs: '5',
        },
        customClassName: 'budget-form mt-2 mt-md-0',
        customDataTestId: 'qa-costcenter-enddate',
      },
      {
        name: 'addIcon',
        type: 'inlineSubmitButton',
        customClassName: 'remove-icon m-0 align-self-end p-0',
        columnType: {
          lg: '1',
          md: '1',
          sm: '1',
          xs: '2',
        },
      },
    ],
  ]
  return formInputData
}

const filterTeamsInput = InfoProps => {
  const { defaultSearchStatus, defaulSearchCostCenter } = InfoProps
  const formInput = [
    {
      type: 'search',
      name: 'searchTerm',
      placeHolderText: i18nTranslate('costCenter.search', 'Search ID or Name'),
      columnType: {
        lg: '9',
        md: '9',
        sm: '12',
      },
      customClassName: 'pr-0 pr-md-2 pr-sm-2',
      dataTestId: 'qa-cost-center-id',
      defaultValue: defaulSearchCostCenter,
    },

    // {
    //   name: i18nTranslate('costcenter.budgetPeriod', 'Budget Period'),
    //   type: 'select',
    //   label: i18nTranslate('costcenter.choose', 'Choose'),
    //   options: budgetPeriodOptions,
    //   dataTestId: 'qa-dropdown',
    //   columnType: {
    //     lg: '4',
    //     md: '6',
    //     sm: '6',
    //     xs: '6',
    //   },
    // },
    {
      name: 'selectTeamStatus',
      type: 'select',
      label: i18nTranslate('status.selectStatus', 'Status'),
      options: [
        { label: i18nTranslate('status.All', 'All'), value: 'All' },
        { label: i18nTranslate('status.active', 'Active'), value: 'Active' },
        {
          label: i18nTranslate('status.inActive', 'Inactive'),
          value: 'Inactive',
        },
      ],
      columnType: {
        lg: '3',
        md: '3',
        sm: '12',
        xs: '12',
      },
      dataTestId: 'qa-cost-center-status',
      defaultValue: defaultSearchStatus,
    },
  ]
  return formInput
}
export { filterTeamsInput }
